module.exports = __webpack_public_path__ + "img/head-shoulders_hover.532751b9.png";